module.exports = __webpack_public_path__ + "static/media/postcard12.5a260709.jpg";